<template>
  <div>
    <div class="row no-gutters">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Master Bonus Reward'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')"
              dataTitleTooltip="Tambah Data" />
          </template>

          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="dataReward" :search="search" class="custom-header">
                <template v-slot:item.no="{ item, index }">
                  {{ item.no }}
                </template>
                <template v-slot:item.status="{ item }">
                  <span v-if="item.status == 1" class="mr-1">Positif</span>
                  <span v-else-if="item.status == 2" class="mr-1">Negatif</span>
                  <span v-else class="mr-1"></span>
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit', item)"
                    dataTitleTooltip="Edit" />
                  <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)"
                    dataTitleTooltip="Hapus" />
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>
      </div>
    </div>

    <b-modal @ok="onSubmit" no-enforce-focus ok-title="Simpan" size="lg" ok-variant="primary" cancel-title="Batal"
      cancel-variant="danger" id="modal" title="Tambah data Bonus Reward">
      <b-form>
        <div class="row no-gutters">
          <div class="col-lg-5">
            <b-form-group label="Kode Penilaian :">
              <b-form-input type="text" required v-model="request.kode_penilaian"
                placeholder="Masukkan Kode Penilaian"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-1"></div>
          <div class="col-lg-6">
            <b-form-group label="Nama Penilaian :">
              <b-form-input type="text" required v-model="request.indikator_penilaian"
                placeholder="Masukkan Nama Penilaian"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-lg-5">
            <b-form-group label="Bobot :">
              <b-form-input type="number" required v-model="request.bobot"
                placeholder="Masukkan Bobot"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-1"></div>
          <div class="col-lg-6">
            <b-form-group label="Status :">
              <Select2 v-model="request.status" :options="statusE" :placeholder="`Pilih Status`"
                :settings="{ settingOption: value, multiple: false, width: '100%' }" />
            </b-form-group>
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Select2 from 'v-select2-component';
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
import axios from "axios";

export default {
  data() {
    return {
      statusE: [
        { id: null, text: '-- Pilih status --' },
        { id: 1, text: "Positif" },
        { id: 2, text: "Negatif" }
      ],
      statusModal: '',
      dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
      dataReward: [],
      request: {
        key: null,
        indikator_penilaian: null,
        kode_penilaian: null,
        status: null,
        bobot: null,
      },
      search: "",
      headers: [
        { text: "No", value: "no", align: "center", sortable: false },
        { text: "Kode Penilaian", value: "kode_penilaian" },
        { text: "Penilaian", value: "indikator_penilaian" },
        { text: "Bobot", value: "bobot" },
        { text: "Status", value: "status" },
        { text: "Aksi", value: "action", sortable: false }
      ],
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent,
    Select2
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Bonus Reward" }
    ]);

    this.getData()
  },
  methods: {
    openModal(status, itemData = null) {
      this.statusModal = status

      // reset form
      this.request = {
        key: null,
        indikator_penilaian: null,
        kode_penilaian: null,
        status: null,
        bobot: null,
      }
      if (status == 'Edit') {
        this.request.key = itemData.key,
        this.request.kode_penilaian = itemData.kode_penilaian,
        this.request.indikator_penilaian = itemData.indikator_penilaian,
        this.request.bobot = itemData.bobot,
        this.request.status = itemData.status
      }
    },

    async getData() {
      try {
        const result = await axios.get(`bonus-reward/all`)
        if (this.dataReward.length > 0) {
          this.dataReward = [];
        }
        result.data.data.map((e, index) => {
          let obj = {
            no: index+1,
            key: e.uuid,
            kode_penilaian: e.kode_penilaian,
            indikator_penilaian: e.indikator_penilaian,
            bobot: e.bobot,
            status: e.status,
          }
          // if (fakultas.status == true) {
            this.dataReward.push(obj);
          // }
        })
        // this.dataReward = result.data.data;
      } catch (err) {
          //this.$swal(`Failed`);
      }
    },

    async onSubmit() {
      const form = this.request
      
      
      if (form.key === null) {
        // store
        this.store(form)
      } else {
        // update
        this.update(form)
      }
    },

    async store(form) {
      try {
        var formData = {
          kode: form.kode_penilaian,
          indicator: form.indikator_penilaian,
          bobot: form.bobot,
          status: parseInt(form.status),
        };
        const result = this.dataReward.find(e => e.kode_penilaian == formData.kode)
        if (result) {
          this.$swal(`Failed Data Already Exist!`);
        }else{
          const result = await axios.post(`bonus-reward/create`, formData)       
          this.refreshData(result, 'Store')
        }
      } catch (err) {
          //this.$swal(`Failed`);
      }
    },

    async update(form) {
      try {
        var formData = {
          kode: form.kode_penilaian,
          indicator: form.indikator_penilaian,
          bobot: form.bobot,
          status: parseInt(form.status),
        };
        const result = await axios.put(`bonus-reward/update/${form.key}`, formData)
        this.refreshData(result, 'Update')
      } catch (err) {
          //this.$swal(`Failed`);
      }
    },

    refreshData(result, alert) {
      if (result.data.meta.code == 200) {
        this.$swal(`Success ${alert} Data`);
        this.getData()
      } else if (result.data.meta.code == 409) {
        this.$swal(`Failed, Data Already Exist!`);
        this.getData()
      } else {
        this.$swal(`Failed ${alert} Data`);
      }
    },

    async deleteData(key) {
      try {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this item!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(async (result) => {
          if (result.value) {
            // User confirmed, so delete the item
            const result = await axios.delete(`bonus-reward/delete/${key}`)
            this.refreshData(result, 'Delete')
          } else {
            // User canceled, so do nothing
          }
        })
      } catch (err) {
          //this.$swal(`Failed`);
      }
    },
  },
};
</script>
